import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MicrosoftPowerbiSvg = function MicrosoftPowerbiSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3C701",
    d: "M19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 19.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M17.348 15.655h-.282v-.538h.282c.602 0 1.09-.465 1.09-1.04V8.577c0-.574-.488-1.04-1.09-1.04H6.652c-.602 0-1.09.466-1.09 1.04v5.504c0 .573.488 1.039 1.09 1.039h.282v.538h-.282c-.439 0-.86-.167-1.17-.463A1.54 1.54 0 0 1 5 14.078V8.576C5 7.706 5.74 7 6.652 7h10.696C18.26 7 19 7.706 19 8.576v5.504c-.001.87-.74 1.574-1.652 1.575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M8.385 17c-.423 0-.766-.327-.766-.731v-1.686c0-.403.341-.73.764-.732.423 0 .766.327.766.731v1.685c0 .404-.341.73-.764.732zM10.029 16.269c0 .404.343.73.766.73a.8.8 0 0 0 .543-.214.72.72 0 0 0 .224-.517V11.94c0-.403-.343-.73-.766-.73-.424 0-.767.326-.767.73zM15.616 16.978c-.423 0-.766-.327-.766-.73v-6.131c0-.261.146-.503.383-.633.237-.131.53-.131.767 0 .237.13.383.372.383.633v6.13c0 .403-.343.73-.766.73zM12.439 16.269c0 .404.343.73.766.73a.79.79 0 0 0 .543-.214.71.71 0 0 0 .224-.517v-3.215c0-.404-.343-.731-.767-.731-.423 0-.766.327-.766.731z"
  }));
};
export var MicrosoftPowerbi = function MicrosoftPowerbi(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MicrosoftPowerbiSvg
  }));
};